import { List, Paper } from "@mui/material";
import React from "react";
import { SystemValueInterface } from "../../Api/System";
import CategoryTitle from "../atoms/CategoryTitle";
import TextFormListItem from "../molecules/TextFormListItem";

interface ReserveSystemSettingsProps {
    systemValue?: SystemValueInterface
    onSave?: (key: string, value: string) => void
}

const ReserveSystemSettings: React.FC<ReserveSystemSettingsProps> = ({
    systemValue,
    onSave
}) => {
    const [reservePendingTimeoutError, setReservePendingTimeoutError] = React.useState(false)
    const [reservePendingTimeoutHelperText, setReservePendingTimeoutHelperText] = React.useState("")

    return (
        <Paper sx={{margin: "10px"}}>
            <CategoryTitle
                text="予約システム関連設定"
            />
            <List>
                <TextFormListItem
                    text="予約タイムアウト時間"
                    endAdornmentText="分"
                    initialValue={systemValue?.RESERVE_PENDING_TIMEOUT ? parseInt(systemValue.RESERVE_PENDING_TIMEOUT).toString() : ""}
                    onValidate={value => {
                        if (isNaN(Number(value))) {
                            setReservePendingTimeoutError(true)
                            setReservePendingTimeoutHelperText("数値を入力してください")
                        } else {
                            setReservePendingTimeoutError(false)
                            setReservePendingTimeoutHelperText("")
                        }
                    }}
                    onSave={value => {
                        if (onSave) {
                            onSave("RESERVE_PENDING_TIMEOUT", value + " MINUTE")
                        }
                    }}
                    error={reservePendingTimeoutError}
                    helperText={reservePendingTimeoutHelperText}
                />
            </List>
        </Paper>
    );
}

export default ReserveSystemSettings